var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiamondOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7945 6.80249H11.2055C10.8 6.81363 10.4028 6.92008 10.0461 7.11324C9.68929 7.30639 9.38299 7.58083 9.15187 7.91438L4.75463 14.0056C4.42812 14.4672 4.26505 15.0247 4.29132 15.5896C4.31758 16.1545 4.53166 16.6944 4.8996 17.1237L18.0913 32.3274C18.3172 32.6187 18.6065 32.8544 18.9374 33.0163C19.2682 33.1785 19.6317 33.2626 20 33.2626C20.3684 33.2626 20.7318 33.1785 21.0627 33.0163C21.3935 32.8544 21.6828 32.6187 21.9087 32.3274L35.1004 17.1237C35.4683 16.6944 35.6824 16.1545 35.7088 15.5896C35.7349 15.0247 35.572 14.4672 35.2454 14.0056L30.8481 7.91438C30.6171 7.58083 30.3108 7.30639 29.954 7.11324C29.5973 6.92008 29.1999 6.81363 28.7945 6.80249Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7432 6.77829L12.8453 15.9151L20.0001 33.1976",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3294 6.77829L27.2031 15.9151L20 33.1976",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33691 15.9152H35.663",
    stroke: "#1E1ffffffE1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamondOutline);
export default __webpack_public_path__ + "static/media/icon_diamond_outline.60c1c66b1fb07254c5b16a08400bdb3c.svg";
export { ForwardRef as ReactComponent };